// extracted by mini-css-extract-plugin
module.exports = {"container":"RegistrationPoster_container_1cfEg","logo":"RegistrationPoster_logo_2y9gS"};